import { render, staticRenderFns } from "./ExCrm.vue?vue&type=template&id=98288d70&scoped=true"
import script from "./ExCrm.vue?vue&type=script&lang=js"
export * from "./ExCrm.vue?vue&type=script&lang=js"
import style0 from "./ExCrm.vue?vue&type=style&index=0&id=98288d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98288d70",
  null
  
)

export default component.exports